import { useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";

const MsGraphInfo = (props) => {
	// const adu = "https://login.microsoftonline.com/78bd1c27-3871-40f2-b397-b39c6d40bf3c";
	const { instance,accounts  } = useMsal();
	
	const callMsGraph = async (token) => {
		const headers = new Headers();
		headers.append("Authorization", `Bearer ${token}`);
		// Add additional fields here
		const fields = ["user","groups"]
		
		return fetch(`https://graph.microsoft.com/v1.0/me/memberOf`, {
			method: "GET",
			headers,
		}).then((response) => response.json())
	}
	
	const requestProfileData = () => {
		instance
			.acquireTokenSilent({
				scopes: ["openid", "profile", "User.Read", "User.Read.All", "Group.Read.All"],
				account:accounts[0]
			})
			.then((response) => {
				callMsGraph(response.accessToken).then((data) => {
					// Do what you want with the data, such as putting it in localstorage
					localStorage.setItem("data", JSON.stringify(data));
				});
			});
	}
	//
	// useEffect(() => {
	// 	requestProfileData();
	// }, [instance]);
	
	requestProfileData();
	return false;
};

export default MsGraphInfo;